<template>
    <button class="pochi-button" :class="className" :style="styles" @click="$emit('click')">
        <slot></slot>
    </button>
</template>

<script>

const colors = [
    'normal',
    'accent',
    'primary',
    'seccondary',
];

// const sizes = [
//     'small',
//     'x-small',
//     'normal',
//     'large',
//     'x-large',
// ];


export default {
    components: {
    },
    props: {
        color: {
            type: String,
            default: 'normal',
            validator: function (value) {
                return colors.indexOf(value ?? 'normal') !== -1;
            },
        },
        small: {
            type: Boolean,
            default: false,
        },
        xSmall: {
            type: Boolean,
            default: false,
        },
        large: {
            type: Boolean,
            default: false,
        },
        xLarge: {
            type: Boolean,
            default: false,
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        // TODO: slotでの指定のがよい
        close: {
            type: Boolean,
            default: false,
        },
        width: {
            type: String,
            default: null,
        },
        height: {
            type: String,
            default: null,
        },
    },
    computed: {
        className: function() {
            return {
                [`pochi-button__color-${this.color}`]: true,
                'pochi-button__size-small':    this.small,
                'pochi-button__size-x-small':  this.xSmall,
                'pochi-button__size-large':    this.large,
                'pochi-button__size-x-large':  this.xLarge,
                'pochi-button__outlined':      this.outlined,
                'pochi-button__close':         this.close,
            };
        },
        styles: function() {
            return {
                width: this.width,
                height: this.height,
            };
        },
    },

}
</script>

<style lang="sass">
.pochi-button
    // TODO: 元のコードのコピーなので見直し必要
    display: inline-block
    border: 1px solid $mainColor
    background: $mainColor
    color: $whiteColor
    cursor: pointer
    font-size: 1.4rem
    padding: 7px 10px
    text-align: center
    vertical-align: middle
    white-space: nowrap
    height: 40px
    transition: 0.2s ease-out

    &:hover
        background: $whiteColor
        color: $grayColor
    &__close
        font-size: 1.7rem
        width: 40px
        line-height: 38px
        padding: 0
    &__close::before
        content: '×'
    &__outlined
        // TODO: ルール決めてから実装
        background: $whiteColor
        color: $grayColor
        &:hover
            background: #cfeee9
            color: $grayColor
    &__color-primary
        // TODO: ルール決めてから実装 $mainColorをprimaryにしたい
    &__color-secondary
        // TODO: ルール決めてから実装
    &__color-accent
        // TODO: ルール決めてから実装
    &__size-small
        // TODO: 調整
        padding: 3px 5px
        font-size: 1.2rem
        height: 34px
    &__size-x-small
        // TODO: 調整
        padding: 1px 2px
        font-size: 1.0rem
        height: 26px
    &__size-large
        // TODO: 調整
        font-size: 2.0rem
        height: 42px
    &__size-x-large
        // TODO: 調整
        font-size: 2.4rem
        height: 50px
</style>
